export enum ListItemVariant {
  Primary = 'primary',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}
